// @context TGW-2923 TW-4251 以前に作った現地払い・無料のチケット（price_type 0/1/2/99）に、
//   事前決済へ切り替える案内を出すかどうか。サーバーは一度も公開していない下書きの初回公開でこのチケットを止める
//   （EventsPlan::CREATOR_TICKET_FIRST_PUBLISH_CONTEXT）が、画面は事前決済以外に料金タイプ欄を出さない（TW-4267）ので、
//   主催者が直せるようボタンを出す。
export const PREPAID_PRICE_TYPE = 3;

// 公式サークル（企業所有）のチケットはサーバーの料金チェックの対象外（EventsPlan#creator_ticket_price_policy_exempt?）。
//   スタッフ・ファシリテーター枠などの無料チケットが正しい仕様なので、有料化を促さない（PR #2959 Copilot 指摘）。
export const shouldShowLegacyTicketNotice = ({ isEditable, priceType, isCompanyOwnedCircle }) =>
  Boolean(isEditable) && !isCompanyOwnedCircle && priceType !== PREPAID_PRICE_TYPE;

// 切り替え後の参加料。下限未満（無料チケットの0円を含む）は下限に引き上げ、それ以上は主催者の金額をそのまま使う
export const prepaidSwitchedPrice = (creatorPrice, minPrice) =>
  Math.max(Number(creatorPrice) || 0, minPrice);
